import { z, ZodType } from "zod";
import ForumName from "notifications/message-notifications/forum-info/forum-name";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";

export type ForumNameParams = z.infer<typeof ForumNameSchema.ForumNameZ>;
export type ForumNameJSON = z.infer<typeof ForumNameSchema.ForumNameJSONZ>;

export default class ForumNameSchema {
  public static readonly type: ZodType<ForumName> = z.custom<ForumName>((value) => value instanceof ForumName, {
    message: "Invalid ForumName",
  });
  public static readonly ForumNameJSONZ = z.string().min(1);

  public static readonly ForumNameZ = z.string().min(1);

  public static readonly codec = z.codec(ForumNameSchema.ForumNameZ, ForumNameSchema.ForumNameJSONZ, {
    decode: (forumNameJSON) => forumNameJSON,
    encode: (forumNameValue) => forumNameValue,
  });

  public static validateParams(values: unknown): ForumNameParams {
    return parseOrThrow(ForumNameSchema.ForumNameZ, values, {
      logError: true,
      schemaName: "ForumNameSchema",
      operation: "validateParams",
      payloadSample: values,
    });
  }

  public static areValidParams(values: unknown): values is ForumNameParams {
    try {
      ForumNameSchema.validateParams(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): ForumNameParams {
    const parsed = parseOrThrow(ForumNameSchema.ForumNameJSONZ, data, {
      logError: true,
      schemaName: "ForumNameSchema",
      operation: "deserialize",
      payloadSample: data,
    });
    return ForumNameSchema.codec.decode(parsed);
  }

  public static serialize(data: ForumNameParams): ForumNameJSON {
    const parsed = ForumNameSchema.validateParams(data);
    return ForumNameSchema.codec.encode(parsed);
  }
}
